import { env } from "../config/env";

const CATALOG_BASE_URL = String(
  env.CATALOG_BASE_URL ||
    process.env.REACT_APP_CATALOG_BASE_URL ||
    process.env.REACT_APP_CATALOG_SERVICE_URL ||
    "http://localhost:6006"
).replace(/\/$/, "");

export function isBase64Image(value) {
  return /^data:image\//i.test(String(value || "").trim());
}

export function resolveRestaurantFoodImageUrl(value) {
  const url = String(value || "").trim();
  if (!url || isBase64Image(url)) return "";

  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("//")) return `${window.location.protocol}${url}`;

  if (url.startsWith("/uploads")) return `${CATALOG_BASE_URL}${url}`;
  if (url.startsWith("uploads/")) return `${CATALOG_BASE_URL}/${url}`;

  return url;
}
